import React from 'react';
import {
  formatCurrency,
  getPaymentTypeIcon,
  getPaymentTypeColor,
  getOperationTypeBadge
} from './kasaBankHelpers';

/**
 * "Przegląd" tab content - shows recent operations in a compact table.
 */
function OverviewTab({ operacje }) {
  if (!operacje || operacje.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
        <i className="fas fa-inbox fa-3x" style={{ marginBottom: '0.6rem', opacity: 0.3 }}></i>
        <p style={{ margin: 0 }}>Brak operacji do wyświetlenia</p>
      </div>
    );
  }

  return (
    <div>
      <h5 style={{ margin: '0 0 1rem 0', fontWeight: '600', color: 'var(--text)' }}>
        Ostatnie Operacje
      </h5>
      <div style={{ overflowX: 'auto', maxHeight: '300px', overflowY: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem', minWidth: '500px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Data', 'Typ', 'Płatność', 'Opis'].map((h) => (
                <th key={h} style={{
                  padding: '0.4rem 0.3rem', textAlign: 'left',
                  fontWeight: '600', color: 'var(--text-secondary)', fontSize: '0.7rem'
                }}>{h}</th>
              ))}
              <th style={{
                padding: '0.4rem 0.3rem', textAlign: 'right',
                fontWeight: '600', color: 'var(--text-secondary)', fontSize: '0.7rem'
              }}>Kwota</th>
            </tr>
          </thead>
          <tbody>
            {operacje.map((operacja, index) => {
              const badge = getOperationTypeBadge(operacja.typ_operacji);
              return (
                <tr key={index} style={{ borderBottom: '1px solid var(--bg)' }}>
                  <td style={{ padding: '0.4rem 0.3rem', fontSize: '0.7rem' }}>
                    {operacja.data_operacji}
                  </td>
                  <td style={{ padding: '0.4rem 0.3rem', fontSize: '0.7rem' }}>
                    <span style={{
                      padding: '0.15rem 0.3rem', borderRadius: '0.2rem',
                      fontSize: '0.65rem', fontWeight: '600',
                      color: badge.color, backgroundColor: badge.bg
                    }}>
                      {badge.text}
                    </span>
                  </td>
                  <td style={{ padding: '0.4rem 0.3rem', fontSize: '0.7rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      <i
                        className={getPaymentTypeIcon(operacja.typ_platnosci)}
                        style={{ color: getPaymentTypeColor(operacja.typ_platnosci), fontSize: '0.7rem' }}
                      ></i>
                      <span style={{ textTransform: 'capitalize' }}>{operacja.typ_platnosci}</span>
                    </div>
                  </td>
                  <td style={{ padding: '0.4rem 0.3rem', fontSize: '0.7rem' }}>
                    {(operacja.opis || '-').substring(0, 25)}
                    {operacja.opis && operacja.opis.length > 25 ? '...' : ''}
                  </td>
                  <td style={{
                    padding: '0.4rem 0.3rem', textAlign: 'right',
                    fontWeight: '600', fontSize: '0.7rem',
                    color: operacja.typ_operacji === 'KP' ? 'var(--success)' : 'var(--danger)'
                  }}>
                    {operacja.typ_operacji === 'KP' ? '+' : '-'}{formatCurrency(operacja.kwota)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OverviewTab;
